import React, {useEffect} from 'react';
import { monthFull, date, getFirstLastDay } from "../helper";

const Filter = (props: any) => {

    useEffect(()=>{

        const Flickity = (window as any).Flickity;
        const elem = document.querySelector('.filter-event');

        const flkty = new Flickity( elem, {
            cellAlign: 'left',
            contain: true,
            initialIndex: props.initialSlide,
            pageDots: false,
        });

        flkty.on( 'staticClick', function( event: any, pointer: any, cellElement: any, cellIndex: number ) {
            props.setFilterData(getFirstLastDay(date, cellIndex));
            flkty.select( cellIndex );
        });

        flkty.on( 'change', function( index: number ) {
            props.setFilterData(getFirstLastDay(date, index));
            flkty.select( index );
        });

        setTimeout(()=>{
            flkty.resize();
        },200);

    },[]);

    return (
        <>
            <div className="filter-event mb-5 mb-lg-8">
                {monthFull.map((item, index)=>{
                    return(
                        <div key={index} className="display-6 text-center text-pansyPurple fw-semibold px-5 py-1">{item}</div>
                    )
                })}
            </div>
        </>
    )
}

export default Filter;